var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.285,
    height: 20.285,
    viewBox: "0 0 20.285 20.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user",
    "data-name": "regular user-circle",
    d: "M10.142,11.926a3.926,3.926,0,1,0,3.926,3.926A3.927,3.927,0,0,0,10.142,11.926Zm0,5.889a1.963,1.963,0,1,1,1.963-1.963A1.964,1.964,0,0,1,10.142,17.815Zm0-9.815A10.142,10.142,0,1,0,20.285,18.142,10.141,10.141,0,0,0,10.142,8Zm0,18.322a8.133,8.133,0,0,1-5.321-1.979,3.523,3.523,0,0,1,2.846-1.615,8.32,8.32,0,0,0,2.474.393,8.191,8.191,0,0,0,2.474-.393,3.534,3.534,0,0,1,2.846,1.615A8.133,8.133,0,0,1,10.142,26.322ZM16.8,22.882a5.425,5.425,0,0,0-4.3-2.123,12.273,12.273,0,0,1-2.356.393,12.339,12.339,0,0,1-2.356-.393,5.437,5.437,0,0,0-4.3,2.123,8.175,8.175,0,1,1,14.833-4.74A8.121,8.121,0,0,1,16.8,22.882Z",
    transform: "translate(0 -8)",
    fill: "#3166b2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.509f68fcec5b63da5c2bafa8b8f265c3.svg";
export { ForwardRef as ReactComponent };